import './Industries.css';
import React, { useState, useEffect, useRef } from "react";
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Banner from '../assets/Industries/silandeIndustries.png';
import WhatsappVerde from '../assets/Home/whatsappVerde.png'
import arrowRight from '../assets/Industries/arrowRight.png';
import arrowDown from '../assets/Industries/arrowDown.png'

// Secciones
import Arquitectura from './Arquitectura/Arquitectura';
import Anticorrosion from './Anticorrosion/Anticorrosion';
import Led from './Led/Led';
import Automotriz from './Automotriz/Automotriz';
import Aeropuertos from './Aeropuertos/Aeropuertos';
import EnergiaSolar from './EnergiaSolar/EnergiaSolar';

function Industries() {
    const [selectedTab, setSelectedTab] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const topRef = useRef(null);

    // Scroll al top al seleccionar tab
    const handleTabClick = (id) => {
        setSelectedTab(id);
        if (topRef.current) {
            topRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Manejar resize para actualizar estado y establecer tab por default en desktop
    useEffect(() => {
        const handleResize = () => {
            const isNowMobile = window.innerWidth < 768;
            setIsMobile(isNowMobile);

            if (!isNowMobile && selectedTab === null) {
                setSelectedTab(1);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [selectedTab]);

    // Si se monta en mobile, arrancar sin tab seleccionada
    useEffect(() => {
        if (window.innerWidth < 768) {
            setSelectedTab(null);
        }
    }, []);

    const tabs = [
        { id: 1, label: 'Arquitectura', component: <Arquitectura /> },
        { id: 2, label: 'Anticorrosión', component: <Anticorrosion /> },
        { id: 3, label: 'Electrónica', component: <Led /> },
        { id: 4, label: 'Automotriz', component: <Automotriz /> },
        { id: 5, label: 'Aeropuertos', component: <Aeropuertos /> },
        { id: 6, label: 'Energía Solar', component: <EnergiaSolar /> },
    ];

    return (
        <>
            <Navbar />
            <div ref={topRef}></div>
            <div className="banner-container-industries">
                <img src={Banner} alt="Banner" className="banner-image-industries" />
            </div>

            {!isMobile ? (
                <ul className="tabs-container-industries">
                    {tabs.map(tab => (
                        <li
                            key={tab.id}
                            className={selectedTab === tab.id ? "tab-industries active" : "tab-industries"}
                            onClick={() => handleTabClick(tab.id)}
                        >
                            {tab.label}
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="accordion-container-industries">
                    {tabs.map(tab => (
                        <div key={tab.id} className="accordion-item-industries">
                            <div
                                className="accordion-header-industries"
                                onClick={() => handleTabClick(selectedTab === tab.id ? null : tab.id)}
                            >
                                <span>{tab.label}</span>
                                <span className="accordion-icon-industries">
                                    <img
                                        src={selectedTab === tab.id ? arrowDown : arrowRight}
                                        alt="arrow"
                                        className="arrow-icon"
                                    />
                                </span>
                            </div>
                            {selectedTab === tab.id && (
                                <div className="accordion-content-industries">
                                    {tab.component}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {!isMobile && selectedTab !== null && (
                <div className="content-container-industries">
                    {tabs.find(tab => tab.id === selectedTab)?.component}
                </div>
            )}

            <Footer />
            <button
                className="whatsapp-button"
                onClick={() => window.open("https://wa.me/+5491151489606", "_blank")}
            >
                <img src={WhatsappVerde} alt="WhatsApp" />
            </button>
        </>
    );
}

export default Industries;
